// extracted by mini-css-extract-plugin
export default {"wrapper":"Player_wrapper__L+x1l"};